<div class="container">
  @if (selectedNodeItem?.id) {
  <div
    class="con-site-details"
    [ngClass]="{
      'details-opened': detailsOpened,
      'details-closed': !detailsOpened
    }"
  >
    <div>
      <b>{{ (this.state.selectedConSite$ | async)?.name }}</b>
      <div (click)="openMap()" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.address }}
      </div>
      <div (click)="openMap()" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.postalCode }}
        {{ (this.state.selectedConSite$ | async)?.city }}
      </div>
      @if (detailsOpened) {
      <div (click)="openPhone(conSite?.phone1)" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.phone1 }}@if
        ((this.state.selectedConSite$ | async)?.contactName1) {
        <span>
          ({{ (this.state.selectedConSite$ | async)?.contactName1 }})</span
        >
        }
      </div>
      } @if (detailsOpened) {
      <div (click)="openPhone(conSite?.phone2)" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.phone2 }}@if
        ((this.state.selectedConSite$ | async)?.contactName2) {
        <span>
          ({{ (this.state.selectedConSite$ | async)?.contactName2 }})</span
        >
        }
      </div>
      } @if (detailsOpened) {
      <div (click)="openMail(conSite?.email1)" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.email1 }}
      </div>
      } @if (detailsOpened) {
      <div (click)="openMail(conSite?.email2)" style="cursor: pointer">
        {{ (this.state.selectedConSite$ | async)?.email2 }}
      </div>
      }
    </div>
    <div class="context-container">
      <ion-icon
        (click)="openContextMenu($event)"
        name="ellipsis-vertical-outline"
        style="font-size: 22px"
      ></ion-icon>
      @if (!detailsOpened) {
      <ion-icon
        (click)="detailsOpened = true"
        name="caret-down-outline"
        style="font-size: 22px"
      ></ion-icon>
      } @if (detailsOpened) {
      <ion-icon
        (click)="detailsOpened = false"
        name="caret-up-outline"
        style="font-size: 22px"
      ></ion-icon>
      }
    </div>
  </div>
  } @if (!selectedNodeItem?.id) {
  <div
    class="whatever"
    [ngClass]="{
      'details-opened': detailsOpened,
      'details-closed': !detailsOpened
    }"
  >
    <div>
      <b>{{ "constructionSites.info" | translate }}:</b>
    </div>
    <div>{{ "constructionSites.noneSelected" | translate }}</div>
  </div>
  }
  <div class="upload-buttons">
    @if(currentFolder()?.id == null && state.userHasMinType(1) &&
    selectedNodeItems.length == 0){
    <ion-button (click)="this.state.openConstructionSiteAlert()">{{
      "constructionSites.new" | translate
    }}</ion-button>
    } @if(child?.breadcrumbs.length > 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1)){
    <ion-button (click)="child?.openMoveFolderModal()"
      ><ion-icon size="small" name="folder-open-outline" slot="start"></ion-icon
      >{{ "common.move" | translate }}
    </ion-button>
    } @if(selectedNodeItems.length == 1 && state.userHasMinType(1)){
    <ion-button (click)="child?.renameFolder()"
      ><ion-icon size="small" name="create-outline" slot="start"></ion-icon
      >{{ "common.edit" | translate }}
    </ion-button>
    } @if(child?.breadcrumbs.length > 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1)){
    <ion-button color="danger" (click)="child?.deleteNodes()"
      ><ion-icon size="small" name="trash-outline"></ion-icon>
    </ion-button>
    } @if(currentFolder()?.id != null && selectedNodeItems.length == 0){
    <ion-button (click)="openFileInput()"
      ><ion-icon
        name="cloud-upload-outline"
        slot="start"
        size="small"
      ></ion-icon
      >{{ "common.uploadDocuments" | translate }}</ion-button
    >
    <input
      type="file"
      id="file"
      class="hidden"
      (change)="fileInput($any($event.target).files)"
      [accept]="state.supportedFileTypes.join(',')"
      multiple
    />
    } @if(child?.breadcrumbs.length == 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1) && selectedNodeItems[0].state != 1){
    <ion-button (click)="archiveConSites()"
      ><ion-icon size="small" slot="start" name="archive-outline"></ion-icon
      >{{ "constructionSites.archive" | translate }}
    </ion-button>
    } @if(child?.breadcrumbs.length == 1 && selectedNodeItems.length > 0 &&
    state.userHasMinType(1) && selectedNodeItems[0].state != 0){
    <ion-button (click)="activateConSites()"
      ><ion-icon
        size="small"
        slot="start"
        name="checkmark-circle-outline"
      ></ion-icon
      >{{ "constructionSites.activate" | translate }}
    </ion-button>
    } @if(currentFolder()?.id != null && selectedNodeItems.length == 0 &&
    this.state.isMobile){
    <ion-button (click)="openCamera()"
      >{{ "camera.open" | translate
      }}<ion-icon size="small" slot="start" name="camera-outline"></ion-icon>
    </ion-button>
    } @if ( currentFolder()?.id != null && selectedNodeItems.length == 0 &&
    state.userHasMinType(1) ) {
    <ion-button (click)="child?.addFolder()"
      ><ion-icon size="small" slot="start" name="add-outline"></ion-icon
      >{{ "common.newFolder" | translate }}</ion-button
    >
    }
  </div>

  <lib-file-tree
    [conSitesMode]="true"
    (selectedNodeItemsChanged)="selectedNodeItemsChanged($event)"
    (currentFolderNodeItemChanged)="currentFolderNodeItemChanged($event)"
    (openFile)="openFile($event)"
    style="width: 100%"
  ></lib-file-tree>
</div>
